import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      transform="scale(1.2 1.2)"
      d="M1.95304 4.02612H0.609375L1.19332 5.23627L4.60983 12.3165L4.60976 12.3166L4.61506 12.3272C5.54398 14.185 7.43111 15.3559 9.50534 15.3559H14.293H15.6393L15.052 14.1444L14.5062 13.0184H18.5858H19.4293V12.1748V11.523C19.4293 10.3678 19.0141 9.35381 18.3679 8.54602L18.3349 8.50475L18.297 8.46792C17.3617 7.55943 16.0977 6.99319 14.6748 6.99319H14.2927H11.5854L11.4784 6.77244C10.6612 5.08356 8.94758 4.02612 7.07782 4.02612H1.95304ZM9.64745 6.99319C9.0525 6.19646 8.10461 5.71322 7.07782 5.71322H3.29671L6.12657 11.5777C6.77193 12.8638 8.07501 13.6688 9.50534 13.6688H12.9466L12.6313 13.0184H10.1794C7.33377 13.0184 4.99775 10.7105 4.99775 7.83674V6.99319H5.8413H9.64745ZM11.8135 11.3313H10.1794C8.54838 11.3313 7.16613 10.2063 6.78743 8.68029H10.5284L11.8135 11.3313ZM13.6883 11.3313L12.4033 8.68029H14.2927H14.6748C15.6154 8.68029 16.4495 9.04323 17.0831 9.64138C17.4588 10.1257 17.6964 10.6948 17.7363 11.3313H14.2927H13.6883Z"
      fill={fill}
    />
  </g>
);

export default Icon;
